import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { Grid, Form } from 'semantic-ui-react';
import moment from 'moment';

import { EditAppliedMenuConfigFieldEnum as Fields } from 'Common/FieldEnum';
import { APPLIED_MENU_CONFIG_FORM_NAME } from 'Common/FormEnum';
import { SelectField, RangeDatePickerField } from 'Common/SemanticWrapper';
import { TitledCard } from 'Components/';
import { ANALYSIS_DAYS_OPTIONS } from 'Pages/managemenu/helpers/Constants';
import { rangeDateValidator } from 'Common/FormHelper';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import * as EditAppliedMenuConfigSelectors from 'Pages/managemenu/state/editappliedmenuconfig/selectors';

class EditAppliedMenuConfigForm extends Component {
  render() {
    const { startDate, endDate } = this.props;

    return (
      <Form>
        <TitledCard>
          <Grid>
            <Grid.Row>
              <Grid.Column width={6} style={{ marginTop: 12 }}>
                <RangeDatePickerField
                  fromName={Fields.StartDate}
                  toName={Fields.EndDate}
                  fromProps={{ startDate, endDate }}
                  toProps={{ startDate, endDate }}
                />
              </Grid.Column>
              <Grid.Column width={4}>
                <Field
                  name={Fields.AnalysisDays}
                  component={SelectField}
                  label="Analysis Days"
                  options={ANALYSIS_DAYS_OPTIONS}
                  fluid
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </TitledCard>
      </Form>
    );
  }
}

const validate = values => {
  const errors = {};

  const startDate = moment(values[Fields.StartDate]);
  const endDate = moment(values[Fields.EndDate]);
  const numberOfDays = moment.duration(endDate.diff(startDate)).asDays() + 1;
  const analysisDays = Number(values[Fields.AnalysisDays]) || 0;

  if (!analysisDays) {
    errors[Fields.AnalysisDays] = 'Field is required.';
  }

  if (numberOfDays > 50) {
    errors[Fields.EndDate] = 'The maximum number of days is 50.';
  }

  if (analysisDays && numberOfDays < analysisDays) {
    errors[Fields.EndDate] =
      'Number of days must be equal to or greater than the selected number of analysis days.';
  }

  const rangeErrors = rangeDateValidator(
    values[Fields.StartDate],
    values[Fields.EndDate],
    {
      dateFormat: DATE_FORMAT_FOR_UI,
      strict: true,
      fromName: Fields.StartDate,
      toName: Fields.EndDate,
      fromLabel: 'From',
      toLabel: 'To',
    }
  );

  return { ...errors, ...rangeErrors };
};

const mapStateToProps = state => ({
  startDate: EditAppliedMenuConfigSelectors.getStartDate(state),
  endDate: EditAppliedMenuConfigSelectors.getEndDate(state),
});

EditAppliedMenuConfigForm = connect(mapStateToProps)(
  reduxForm({
    form: APPLIED_MENU_CONFIG_FORM_NAME,
    validate,
    destroyOnUnmount: false,
    enableReinitialize: true,
  })(EditAppliedMenuConfigForm)
);

export { EditAppliedMenuConfigForm };



// WEBPACK FOOTER //
// ./src/pages/managemenu/components/EditAppliedMenuConfigForm.js